import React from 'react';
import { Segment, Grid, Image } from 'semantic-ui-react';
import '../../assets/css/utils.css';
import tfuncion from '../../assets/img/tfuncion.jpg';
import tcorpus from '../../assets/img/tcorpus.jpg';
import texpresion from '../../assets/img/texpresion.jpg';

const How2use = () => (
  <div>
    <Segment placeholder>
      <Grid divided='vertically'>        
        <Grid.Row columns={1}>
          <Grid.Column>
            <Segment className="harta-text-justified harta-home-style ph2">
              <p></p>
              <p>En este apartado podrás visualizar unos videos tutoriales correspondientes a 
              las distintas secciones de HARTA.</p>
              <p>Antes de empezar a utilizar la herramienta 
              te recomendamos su visualización.</p>
              <p></p>
            </Segment>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={3}>
          <Grid.Column>
            <Segment attached>
              <Image src={texpresion} as='a' size='medium' href='https://www.youtube.com/watch?v=uzU9LdXgcfU' target='blank_' className="mystyle3"/>
              <p></p>
              <p><b>Expresión académica</b></p>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment attached>
              <Image src={tfuncion} as='a' size='medium' href='https://www.youtube.com/watch?v=BwtoyuHBqSs' target='blank_' className="mystyle3"/>
              <p></p>
              <p><b>Funciones discursivas</b></p>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment attached>
              <Image src={tcorpus} as='a' size='medium' href='https://www.youtube.com/watch?v=rLTbrnCVApc' target='blank_' className="mystyle3"/>
              <p></p>
              <p><b>Búsqueda en Corpus</b></p>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  </div>
);

export default How2use;